import { useAppEventBusContext } from '@/context/eventBusContext';
import { SubscribeEvent } from '@/interface/event';
import { useSignalStore } from '@/page/token/signal/store';
import tokenApiService from '@/request/token/token.api.service';
import { getAllAssociatedTokens, useBoomWallet } from '@boomeme/wallet-sdk';
import { useEffect } from 'react';

export interface IHolding {
  tokenAddress: string;
  amount: string;
  decimals: number;
}

export const useSignalHoldingList = () => {
  const { isConnected, walletAddress, chain } = useBoomWallet();
  const { setHoldingList } = useSignalStore();
  const { subscribe } = useAppEventBusContext();

  const getSolHoldingList = async () => {
    if (isConnected && walletAddress && chain == 'solana') {
      const tokenList = await getAllAssociatedTokens(walletAddress);
      const hasBalanceTokenList = tokenList
        .filter((item) => item.uiAmount !== 0)
        .map((item) => ({
          tokenAddress: item.tokenAddress,
          amount: item.uiAmountString || '0',
          decimals: item.decimals,
        }));
      setHoldingList(hasBalanceTokenList);
    }
  };

  const getBscHoldingList = async () => {
    if (!isConnected || !walletAddress || chain !== 'bsc') return;
    const res = await tokenApiService.getEvmWalletHoldingList({ wallet: walletAddress });
    if (res.code !== 0) return;
    const list = res.data.map((item) => ({
      tokenAddress: item.address,
      amount: item.balance,
      decimals: item.decimals,
    }));
    setHoldingList(list);
  };

  useEffect(() => {
    getSolHoldingList();
    getBscHoldingList();
    const unsubscribe = subscribe(SubscribeEvent.Update_Balance, () => {
      getSolHoldingList();
    });
    return () => unsubscribe();
  }, [isConnected, walletAddress]);
};
